import { render, staticRenderFns } from "./AppLanguageBar.vue?vue&type=template&id=1cfd0249&scoped=true&"
import script from "./AppLanguageBar.vue?vue&type=script&lang=js&"
export * from "./AppLanguageBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfd0249",
  null
  
)

export default component.exports